var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import 'react-dates/initialize';
import { DayPickerRangeController, } from 'react-dates';
import DatePickerProvider from './DatePickerProvider';
import Icon, { CalendarIcon } from '../Icon';
import TextField from '../TextField';
import Box from '../Box';
/**
 * Kareo wrapped component of the react-dates library Date Range Picker
 *
 * Date Range Picker: [Docs](http://airbnb.io/react-dates), [API](https://www.npmjs.com/package/react-dates/)
 *
 * @storybook: [Date Range Picker](http://design.kareoprod.ent/design-system/?path=/story/components-inputs-daterangepicker--date-range-picker-main)
 */
var DateRangePicker = React.forwardRef(function (_a, ref) {
    var startValue = _a.startValue, endValue = _a.endValue, startLabel = _a.startLabel, endLabel = _a.endLabel, onStartChange = _a.onStartChange, onEndChange = _a.onEndChange, textFieldProps = _a.textFieldProps, props = __rest(_a, ["startValue", "endValue", "startLabel", "endLabel", "onStartChange", "onEndChange", "textFieldProps"]);
    var _b = React.useState('startDate'), input = _b[0], setInput = _b[1];
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var startDateString = startValue ? startValue.format('MM/DD/YYYY') : '';
    var endDateString = endValue ? endValue.format('MM/DD/YYYY') : '';
    var handleDatesChange = function (arg) {
        if (!arg.startDate ||
            startDateString !== arg.startDate.format('MM/DD/YYYY')) {
            onStartChange(arg.startDate);
        }
        if (arg.endDate && endDateString !== arg.endDate.format('MM/DD/YYYY')) {
            onEndChange(arg.endDate);
            setOpen(false);
        }
    };
    var handleFocusChange = function (focused) {
        setInput(!focused ? 'startDate' : focused);
    };
    return (React.createElement(DatePickerProvider, { style: { position: 'relative' } },
        React.createElement(Box, { component: "span", marginRight: 1 },
            React.createElement(TextField, __assign({}, textFieldProps, { type: "text", label: !startLabel ? '' : startLabel, value: startDateString, onClick: function () {
                    setOpen(!open);
                    setInput('startDate');
                }, InputProps: __assign(__assign({}, textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps), { readOnly: true, endAdornment: React.createElement(CalendarIcon, { fontSize: "small" }) }) }))),
        React.createElement(TextField, __assign({}, textFieldProps, { type: "text", label: !endLabel ? '' : endLabel, value: endDateString, onClick: function () {
                setOpen(!open);
                setInput('endDate');
            }, InputProps: __assign(__assign({}, textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps), { readOnly: true, endAdornment: React.createElement(CalendarIcon, { fontSize: "small" }) }) })),
        open ? (React.createElement(Box, { component: "div", position: "absolute", left: 0, zIndex: 2 },
            input === 'startDate' ? (React.createElement(Box, { marginBottom: -2.4, marginLeft: 1.1, marginTop: 1 },
                React.createElement(Icon, null,
                    React.createElement("path", { d: "M0,10 10,0 20,10", fill: "#EDEEF1", stroke: "#EDEEF1" })))) : (React.createElement(Box, { marginBottom: -2.4, marginLeft: 29.2, marginTop: 1 },
                React.createElement(Icon, null,
                    React.createElement("path", { d: "M0,10 10,0 20,10", fill: "#EDEEF1", stroke: "#EDEEF1" })))),
            React.createElement(DayPickerRangeController, __assign({}, props, { ref: ref, focusedInput: input, onFocusChange: handleFocusChange, startDate: startValue, endDate: endValue, onDatesChange: handleDatesChange, initialVisibleMonth: null, hideKeyboardShortcutsPanel: true })))) : ('')));
});
DateRangePicker.displayName = 'KareoDateRangePicker';
export default DateRangePicker;
